import React, { useEffect, useState } from 'react';
import ErrorService, { ErrorState } from '../../services/ErrorService';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const ErrorAlert = () => {
  const { t } = useTranslation();
  const [errorState, setErrorState] = useState<ErrorState>({ error: null });

  useEffect(() => {
    ErrorService.getState(setErrorState);
  }, []);

  const showErrorToast = (message: string) => {
    return toast.error(message, {
      autoClose: 10000,
      onOpen: () => ErrorService.clearError(),
    });
  };

  useEffect(() => {
    if (errorState.error) {
      const error = errorState.error;
      const statusCode = error.response?.status;
      const message = statusCode ? t('ApiRequestErrorWithStatusCode', { statusCode: statusCode }) : t('ApiRequestError') + error.message;
      showErrorToast(message);
    }
  }, [errorState]);

  return <></>;
};

export default ErrorAlert;
